"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _status = require("./status");
const initialState = {
  values: null,
  status: _status.configStatus.INACTIVE,
  errorMessage: ''
};
const updateConfig = (state, action) => {
  const filteredValues = Object.fromEntries(Object.entries(action.payload).filter(_ref => {
    let {
      1: value
    } = _ref;
    return value !== undefined;
  }));
  state.values = {
    ...state.values,
    ...filteredValues
  };
};
const configSlice = exports.configSlice = (0, _toolkit.createSlice)({
  name: 'config',
  initialState,
  reducers: {
    loadConfig: state => {
      state.status = _status.configStatus.PENDING;
      state.errorMessage = '';
    },
    loadSuccess: (state, action) => {
      state.status = _status.configStatus.SUCCESS;
      state.errorMessage = '';
      updateConfig(state, action);
    },
    updateConfig,
    loadFailure: (state, action) => {
      state.status = _status.configStatus.ERROR;
      state.errorMessage = action.payload;
    }
  }
});